import { Currency } from "./currency";
import CurrencyRestrictions from "./currencyRestrictions";

export function getCurrencyRestrictions(currency: string) {
  if (currency === Currency.MNDE) {
    return CurrencyRestrictions.MNDE;
  }

  if (currency === Currency.MPLX) {
    return CurrencyRestrictions.MPLX;
  }

  if (currency === Currency.SWTCH) {
    return CurrencyRestrictions.SWTCH;
  }

  if (currency === Currency.SOL) {
    return CurrencyRestrictions.SOL;
  }

  if (currency === Currency.DRVS) {
    return CurrencyRestrictions.DRVS;
  }

  if (currency === Currency.USDC) {
    return CurrencyRestrictions.USDC;
  }

  if (currency === Currency.ZRC) {
    return CurrencyRestrictions.ZRC;
  }

  throw new Error(`Currency ${currency} not found`);
}

export function getCurrencyRestrictionsForAllCurrencies() {
  return CurrencyRestrictions;
}

export function getCurrencyMinimumWithdrawalAmount(
  currency: string | undefined,
) {
  if (!currency) {
    return 0;
  }

  const restrictions = getCurrencyRestrictions(currency);
  return restrictions.minimumWidrawalAmount ?? 0;
}

export function isCurrencyAllowedForWithdrawal(currency: string | undefined) {
  if (!currency) {
    return true;
  }

  const restrictions = getCurrencyRestrictions(currency);
  return restrictions.allowsWithdrawals;
}
